// @flow

import type {OppslutningEnkelGraphProps} from '../../components/oppslutningEnkel/OppslutningEnkelGraph'

type Data = {
  id: string,
  title: string,
  description: string,
  source?: string,
  graphProps: OppslutningEnkelGraphProps
}
// export type OppslutningEnkelGraphItem = {
//   navn: string,
//   kortNavn: string,
//   prosent: number,
//   endringProsent: number,
//   antallStemmer: number,
//   sortering: number
// }
// export type OppslutningEnkelGraphProps = {
//   id: string,
//   items: Array<OppslutningEnkelGraphItem>,
//   type: 'land' | 'fylke' | 'kommune' | 'krets',
//   headingLevel: number
// }

function mapDataToProps(data: any): Data {
  return {
    id: data.id || 'root',
    title: data.title,
    description: data.description,
    source: data.source,
    graphProps: {
      id: 'static',
      headingLevel: 3,
      type: 'land',
      items: data.partier.map((d, idx) => {
        return {
          id: String(idx),
          navn: d.navn,
          kortNavn: d.kortNavn,
          prosent: d.prosent,
          endringProsent: d.endringProsent,
          antallStemmer: d.antallStemmer
        }
      })
    }
  }
}

export default mapDataToProps



// WEBPACK FOOTER //
// ./src/shared/containers/OppslutningEnkelWidget/mapDataToProps.js